'use strict';
/**
 * Test whether a value is a BigNumber
 * @param {*} x
 * @return {boolean}
 */

module.exports = function isBigNumber(x) {
  return x && x.constructor.prototype.isBigNumber || false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/utils/bignumber/isBigNumber.js
// module id = pedh
// module chunks = 0